var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable max-len */
import { useState, useEffect } from 'react';
import ReactModal from 'react-modal';
import { useWaitingListSettings } from '../../../../../modules/shared/appointments/walk-in-list/hooks/use-waiting-list-settings';
import './waitlist-settings.scss';
export var WaitlistSettings = function (_a) {
    var isOpen = _a.isOpen, onRequestClose = _a.onRequestClose, onSaveSettings = _a.onSaveSettings, _b = _a.isLoading, isLoading = _b === void 0 ? false : _b;
    var waitingListSettings = useWaitingListSettings().data;
    // Initialize state directly from server data or defaults
    var initialSettings = waitingListSettings || {
        canCustomerEnrollToWalkInList: false,
        allowMultipleServices: false,
        timezone: '',
        shortLink: '',
    };
    var _c = useState(initialSettings), settings = _c[0], setSettings = _c[1];
    // Reset local state when server data changes (e.g., after successful save)
    useEffect(function () {
        if (waitingListSettings) {
            setSettings(waitingListSettings);
        }
    }, [waitingListSettings]);
    var handleReset = function () {
        if (waitingListSettings) {
            setSettings(waitingListSettings);
        }
    };
    // TODO: Implement save logic
    var handleShowResults = function () {
        onSaveSettings({
            canCustomerEnrollToWalkInList: settings.canCustomerEnrollToWalkInList,
            allowMultipleServices: settings.allowMultipleServices,
            timezone: settings.timezone,
            shortLink: settings.shortLink,
        });
    };
    return (_jsx(ReactModal, { isOpen: isOpen, onRequestClose: onRequestClose, className: {
            base: 'waitlist-settings-modal',
            afterOpen: 'waitlist-settings-modal--open',
            beforeClose: 'waitlist-settings-modal--closing',
        }, overlayClassName: {
            base: 'waitlist-settings-overlay',
            afterOpen: 'waitlist-settings-overlay--open',
            beforeClose: 'waitlist-settings-overlay--closing',
        }, ariaHideApp: false, contentLabel: "Waitlist settings", shouldCloseOnOverlayClick: true, children: _jsxs("div", { className: "waitlist-settings-panel", children: [_jsxs("div", { className: "waitlist-settings-header", children: [_jsx("h2", { children: "Waitlist settings" }), _jsx("button", { className: "waitlist-settings-close", onClick: onRequestClose, "aria-label": "Close", children: "\u00D7" })] }), _jsxs("div", { className: "waitlist-settings-section", children: [_jsx("div", { className: "waitlist-settings-section-label", children: "WALK-IN MANAGEMENT" }), _jsxs("label", { className: "waitlist-settings-checkbox", htmlFor: "walkInsCanAddThemselves", children: [_jsx("input", { id: "walkInsCanAddThemselves", type: "checkbox", checked: settings === null || settings === void 0 ? void 0 : settings.canCustomerEnrollToWalkInList, onChange: function (e) { return setSettings(__assign(__assign({}, settings), { canCustomerEnrollToWalkInList: e.target.checked })); } }), "Walk-ins can add themselves to the list"] }), _jsx("div", { className: "waitlist-settings-link-label", children: "PUBLIC WALK-IN LINK" }), _jsxs("div", { className: "waitlist-settings-link-row", children: [_jsx("input", { id: "publicWalkInLink", type: "text", className: "waitlist-settings-link-input", value: settings === null || settings === void 0 ? void 0 : settings.shortLink, onChange: function (e) { return setSettings(__assign(__assign({}, settings), { shortLink: e.target.value })); } }), _jsx("button", { className: "waitlist-settings-link-copy", onClick: function () { return navigator.clipboard.writeText(settings === null || settings === void 0 ? void 0 : settings.shortLink); }, "aria-label": "Copy link", children: _jsx("span", { role: "img", "aria-label": "Copy", children: "\uD83D\uDCCB" }) })] })] }), _jsxs("div", { className: "waitlist-settings-footer", children: [_jsx("button", { className: "waitlist-settings-reset", onClick: handleReset, disabled: isLoading, children: "Reset" }), _jsx("button", { className: "waitlist-settings-save", onClick: handleShowResults, disabled: isLoading, children: isLoading ? 'Saving...' : 'Save' })] })] }) }));
};
export default WaitlistSettings;
